import { MapPin, Plane, Car, Briefcase, School, ShoppingBag, Landmark, Users, Dices, Biohazard, Droplet, Sun, Wifi, HandCoins, Building, BookOpen, Scaling, HeartPulse, HeartPulseIcon, Dog } from "lucide-react";

export const msrcityIconMap = {
  "Tech Cloud": <Building className="w-6 h-6 text-accent" />,
  "Aero City": <Plane className="w-6 h-6 text-accent" />,
  "Signature Business Park": <Briefcase className="w-6 h-6 text-accent" />,
  "13 Degree Mall": <ShoppingBag className="w-6 h-6 text-accent" />,
  "JW Marriot International": <Landmark className="w-6 h-6 text-accent" />,
  "Kempegowda International Airport": <Plane className="w-6 h-6 text-accent" />,
  "NH44 Bellary Road": <Car className="w-6 h-6 text-accent" />,
  "Upcoming Dodajalla Metro Station": <Car className="w-6 h-6 text-accent" />,
  "Upcoming Peripheral Ring Road": <Car className="w-6 h-6 text-accent" />,
  "Satellite Town Ring Road": <Car className="w-6 h-6 text-accent" />,
  "Karle Town SEZ": <Briefcase className="w-6 h-6 text-accent" />,
  "IFCI Financial City": <HandCoins className="w-6 h-6 text-accent" />,
  "Ecopolis Hinduja": <Briefcase className="w-6 h-6 text-accent" />,
  "Bagmane Sierra Business District": <Briefcase className="w-6 h-6 text-accent" />,
  "Horizon (Amazon Office)": <Briefcase className="w-6 h-6 text-accent" />,
  "KIADB Hardware Tech Park": <Briefcase className="w-6 h-6 text-accent" />,
  "KIADB Aerospace Tech Park": <Briefcase className="w-6 h-6 text-accent" />,
  "Manyata Tech Park": <Briefcase className="w-6 h-6 text-accent" />,
  "L&T Tech Park": <Briefcase className="w-6 h-6 text-accent" />,
  "Delhi Public School Bangalore North": <School className="w-6 h-6 text-accent" />,
  "Canadian International School": <School className="w-6 h-6 text-accent" />,
  "Ryan International School": <School className="w-6 h-6 text-accent" />,
  "Jawahar Navodaya Vidyalaya": <School className="w-6 h-6 text-accent" />,
  "Stone Hill International School": <School className="w-6 h-6 text-accent" />,
  "Sir M. Visvesvaraya Institute of Technology": <BookOpen className="w-6 h-6 text-accent" />,
  "Reva University": <BookOpen className="w-6 h-6 text-accent" />,
  "Relive Hospital": <HeartPulse className="w-6 h-6 text-accent" />,
  "Manipal Hospital": <HeartPulse className="w-6 h-6 text-accent" />,
  "Aster CMI Hospital": <HeartPulse className="w-6 h-6 text-accent" />,
  "Baptist Hospital": <HeartPulse className="w-6 h-6 text-accent" />,
  "Cyte Care Hospital": <HeartPulse className="w-6 h-6 text-accent" />,
  "Sparsh Hospital": <HeartPulseIcon className="w-6 h-6 text-accent" />,
  "Elements Mall": <ShoppingBag className="w-6 h-6 text-accent" />,
  "Taj Airport Hotel": <Landmark className="w-6 h-6 text-accent" />,
  "Mall of Asia": <ShoppingBag className="w-6 h-6 text-accent" />,
  "Galleria Mall": <ShoppingBag className="w-6 h-6 text-accent" />,
  "Bharthiya Mall of Bengaluru": <ShoppingBag className="w-6 h-6 text-accent" />,
  "CHILDRENS’ PLAY AREA & SENIOR CITIZEN ZONE": <Users className="w-6 h-6 text-accent" />,
  "LAWN AREA WITH SEATING": <Sun className="w-6 h-6 text-accent" />,
  "PADDLE COURT": <Dices className="w-6 h-6 text-accent" />,
  "SAND VOLLEY BALL": <Dices className="w-6 h-6 text-accent" />,
  "GAUDI LEISURE, JACUZZI & KIDS' POOL": <Droplet className="w-6 h-6 text-accent" />,
  "KIDS' SKATING RINK": <Biohazard className="w-6 h-6 text-accent" />,
  "SKATING PARK": <Biohazard className="w-6 h-6 text-accent" />,
  "SKATE BOARDING RINK": <Biohazard className="w-6 h-6 text-accent" />,
  "OUTDOOR SCREEN AND AMPHI SEATING": <Wifi className="w-6 h-6 text-accent" />,
  "SAND PIT": <Landmark className="w-6 h-6 text-accent" />,
  "PALM COURT": <Sun className="w-6 h-6 text-accent" />,
  "LAP POOL": <Droplet className="w-6 h-6 text-accent" />,
  "YOGA AND MEDITATION COURT": <Users className="w-6 h-6 text-accent" />,
  "OUTDOOR GYM": <Scaling className="w-6 h-6 text-accent" />,
  "PLAZA WITH FOUNTAIN SEATING": <Sun className="w-6 h-6 text-accent" />,
  "LAWN AREA": <Sun className="w-6 h-6 text-accent" />,
  "FUTSAL & TENNIS COURT": <Dices className="w-6 h-6 text-accent" />,
  "PICKLE COURT": <Dices className="w-6 h-6 text-accent" />,
  "NET CRICKET": <Dices className="w-6 h-6 text-accent" />,
  "MINI GOLF": <Dices className="w-6 h-6 text-accent" />,
  "BUTTERFLY & FLOWER GARDEN": <Sun className="w-6 h-6 text-accent" />,
  "PET PARK": <Dog className="w-6 h-6 text-accent" />,
  "PLAZA WITH SEATING AREA UNDER TREE CANOPIES": <Sun className="w-6 h-6 text-accent" />,
  "CABANAS & GAZEBO WITH GRAPE WINE WALKWAY": <Sun className="w-6 h-6 text-accent" />,
  "CYCLE TRACK": <Car className="w-6 h-6 text-accent" />,
  "JOGGING TRACK": <Car className="w-6 h-6 text-accent" />,
  "WALL CLIMBING & KIDS' PLAY AREA": <Users className="w-6 h-6 text-accent" />,
  "SCULPTURE SEATING AREA": <Landmark className="w-6 h-6 text-accent" />,
  "default": <MapPin className="w-6 h-6 text-accent" />,
};